import React, { useState, useEffect } from 'react';
import { api } from '../../api';
import { colors, fontFamily } from '../../theme';
import AgentCustomerDetailModal from './AgentCustomerDetailModal';
import AccountTemplateModal from '../shared/AccountTemplateModal';

export default function CustomerAdminSection({ perms }) {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [showApplyAll, setShowApplyAll] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await api.getAccounts();
      setAccounts(data.users || []);
    } catch (err) {
      console.error('Failed to load customers:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const customers = accounts.filter(u => u.role === 'customer');
  // Any customer field the agent is allowed to change → the template is worth offering.
  const canApplyAll = ['can_change_credit_limit', 'can_change_wager_limit', 'can_change_parlay_limit',
    'can_change_live_wager_limit', 'can_change_casino_limit', 'can_change_casino_weekly_limit',
    'can_change_free_play_limit', 'can_change_contest_limit', 'can_allow_deny_casino', 'can_suspend_wagering']
    .some(k => perms && perms[k]);

  if (loading) {
    return <p style={{ color: colors.textMuted, fontFamily }}>Loading customers...</p>;
  }

  return (
    <div style={{ color: colors.textPrimary, fontFamily }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h2 style={{ color: colors.textPrimary, margin: 0 }}>Customer Admin ({customers.length})</h2>
        {customers.length > 0 && canApplyAll && (
          <button
            onClick={() => setShowApplyAll(true)}
            style={{ background: colors.goldActiveBg, border: `1px solid ${colors.gold}`, color: colors.textPrimary, borderRadius: 6, padding: '0.4rem 0.9rem', cursor: 'pointer', fontWeight: 700, fontFamily, fontSize: '0.85rem' }}
          >
            Apply to All
          </button>
        )}
      </div>
      <div style={{ display: 'grid', gap: '0.5rem' }}>
        {customers.map(c => (
          <button
            key={c.id}
            onClick={() => setSelected(c)}
            style={{ textAlign: 'left', background: colors.cardBg, boxShadow: colors.shadowCard, border: 'none', borderRadius: 8, padding: '0.75rem 1rem', color: colors.textPrimary, cursor: 'pointer', fontFamily }}
          >
            <span style={{ fontWeight: 600 }}>{c.name}</span>
            <span style={{ color: colors.textMuted, marginLeft: '0.5rem' }}>@{c.username}</span>
            {!c.is_active && (
              <span style={{ marginLeft: '0.5rem', fontSize: '0.75rem', padding: '2px 8px', borderRadius: 20, background: 'rgba(220,53,69,0.2)', color: colors.negative }}>Disabled</span>
            )}
          </button>
        ))}
      </div>

      {selected && (
        <AgentCustomerDetailModal
          user={selected}
          perms={perms}
          onClose={() => setSelected(null)}
          onUpdate={load}
        />
      )}

      {showApplyAll && (
        <AccountTemplateModal
          scope="customer"
          targetLabel="customers"
          targetCount={customers.length}
          perms={perms}
          onClose={() => setShowApplyAll(false)}
          onApplied={load}
        />
      )}
    </div>
  );
}
